import {
  AccountingEventsGroup,
  DigitalBusinessDocument,
  DigitalCostDocument,
} from "../types";
import { isDigitalDocument } from "./typeChecks";
import { FlowType } from "../hooks/useFlowType";

export function shouldHideAccountingFlow(
  events: (
    | AccountingEventsGroup
    | DigitalBusinessDocument
    | DigitalCostDocument
  )[],
  contextGlProduct?: string | number
): boolean {
  const hasDocumentEvents = events.some((event) => isDigitalDocument(event));

  const isTvodOrder =
    contextGlProduct === "TVOD" ||
    contextGlProduct === "318" ||
    contextGlProduct === 318;

  // For TVOD with document flow, hide accounting flow (short term until accounting groups turned off)
  return isTvodOrder && hasDocumentEvents;
}

export function shouldHideDocumentFlow(
  events: (
    | AccountingEventsGroup
    | DigitalBusinessDocument
    | DigitalCostDocument
  )[]
): boolean {
  return !events.some((event) => isDigitalDocument(event));
}

// These display names are used for health status steps, they only show when both flows are present for an order
export function getFlowDisplayName(flowType: FlowType): string {
  switch (flowType) {
    case "document":
      return "Royalty Flow"; // If there is document + accounting flow, then document is used for royalties
    case "accounting":
      return "Revenue Flow";
    default:
      return "Unknown Flow";
  }
}
